import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epShowLastFourCharacters',
    standalone: false
})
export class ShowLastFourCharactersPipe implements PipeTransform {
    transform(value: string) {
        if (!value) {
            return value;
        }

        if (value.length <= 4) {
            return value;
        }

        let lastFour = value.slice(value.length - 4, value.length);
        let priorFour = Array.from(value.slice(0, value.length - 4));
        let priorFourMask = priorFour.fill('*').join('');

        return priorFourMask + lastFour;
    }
}
